/**
 * Tracking helper
 *
 * @type {Object}
 */
export const TrackingHelper = {
  getBasicDealerOptions(options) {
    const location = options.state && options.state.pageContext.location;
    const pathNameMatch = location.pathname.match(/(\w+)/g);
    const dealerInfo = options.state.dealerData.dealerInfo;
    const dealerLogicalName = pathNameMatch[3];
    const partnerId = dealerInfo.name[dealerLogicalName] && dealerInfo.name[dealerLogicalName].id;

    return {
      partner_id: partnerId,
    };
  },
};
